import { render, staticRenderFns } from "./TextDirectionToggle.vue?vue&type=template&id=296323d4&"
import script from "./TextDirectionToggle.vue?vue&type=script&lang=ts&"
export * from "./TextDirectionToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports